export default __webpack_public_path__ + "static/media/owsBlack.b92e1aca.svg";